package io.horion.auth.di

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import org.koin.core.context.GlobalContext
import org.koin.core.parameter.ParametersDefinition
import org.koin.core.parameter.parametersOf
import org.koin.core.qualifier.Qualifier
/**
 * Helper pour récupérer des instances depuis Koin dans Compose
 */
@Composable
inline fun <reified T : Any> koinGet(
    qualifier: Qualifier? = null,
    noinline parameters: ParametersDefinition? = null
): T {
    return remember(qualifier, parameters) {
        GlobalContext.get().get<T>(qualifier, parameters)
    }
}

/**
 * Helper pour récupérer des instances factory avec paramètres depuis Koin
 */
@Composable
inline fun <reified T : Any> koinFactory(
    noinline parameters: ParametersDefinition
): T {
    return remember(parameters) {
        GlobalContext.get().get<T>(parameters = parameters)
    }
}
/**
 * Helper spécialement pour les paramètres simples
 */
@Composable
inline fun <reified T : Any> koinFactoryOf(vararg params: Any): T {
    return remember(*params) {
        GlobalContext.get().get<T> { parametersOf(*params) }
    }
}